import {
  orgWalletControllerGetTransactions,
  userWalletControllerGetTransactions,
} from "@/generated/api/api";
import {
  OrgTransactionResponseDTO,
  TransactionResponseDTO,
} from "@/generated/api/models";
import { useInfiniteQuery } from "@tanstack/react-query";
import { useState } from "react";
import { DateRange } from "./date.picker.types";

export function useTransactionListQuery(organizationId?: string) {
  const [selectedRange, setSelectedRange] = useState<DateRange>();

  const selectedRangeString = selectedRange
    ? {
        startTime: selectedRange[0].toISOString(),
        endTime: selectedRange[1].toISOString(),
      }
    : undefined;

  return {
    selectedRange,
    setSelectedRange,
    infiniteQuery: useInfiniteQuery({
      initialPageParam: "",
      queryKey: [organizationId, "transactions", selectedRangeString],
      queryFn: (
        ctx
      ): Promise<TransactionResponseDTO | OrgTransactionResponseDTO> => {
        if (organizationId) {
          return orgWalletControllerGetTransactions(organizationId, {
            limit: 15,
            position: ctx.pageParam,
            ...selectedRangeString,
          });
        } else {
          return userWalletControllerGetTransactions({
            limit: 15,
            position: ctx.pageParam,
            ...selectedRangeString,
          });
        }
      },
      getNextPageParam: (lastPage) => lastPage?.next,
      getPreviousPageParam: (lastPage) => lastPage?.previous,
    }),
  };
}
